import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelVariantSetpointsList from './ModelVariantSetpointsList';
import { getModelVariantSetpoints, getUserOrgModelCategoryType, getUserProfileWidget, getModelCategorySetpoints, getCurrentTimezone } from '../../selectors/index';
import {
  getModelVariantSetpointsThunk,
  describeModelVariantSetpointsThunk,
  saveModelVariantSetpointsThunk,
  setModelVariantSetpointsChangeThunk,
  setModelVariantSetpointShowScreenStatusThunk,
  setCurrentPage,
  setPageFilter,
  setModelVariantSetpointsFilteredDataThunk
} from '../../actions/modelVariantSetpoints';

const mapStateToProps = state => {
  return {
    modelVariantSetpoints: getModelVariantSetpoints(state),
    currentTimezone: getCurrentTimezone(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state),
    modelCategorySetpoints: getModelCategorySetpoints(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelVariantSetpoints: (modelVaraintId, modelId) => getModelVariantSetpointsThunk(modelVaraintId, modelId, 'MODELVARIANTSETPOINTS'),
      saveModelVariantSetpoint: (modelVariantSetpoint, widgetCode) => saveModelVariantSetpointsThunk(modelVariantSetpoint, widgetCode),
      describeModelVariantSetpoint: (modelId, modelVariantSetpointId) => describeModelVariantSetpointsThunk(modelId, modelVariantSetpointId, 'MODELVARIANTSETPOINTSEDIT'),
      changeModelVariantSetpoint: selectedModelVariantSetpoints => setModelVariantSetpointsChangeThunk(selectedModelVariantSetpoints),
      setModelVariantSetpointShowScreenStatus: status => setModelVariantSetpointShowScreenStatusThunk(status),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setModelVariantSetpointsFilteredDataThunk(filteredData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariantSetpointsList);
